import { useReturnToPrevious } from "../misc/useReturnToPrevious";
import { type MutationMode } from "ra-core";
import { useLocation } from "react-router";
import { useIsMobile } from "@/hooks/use-mobile";
import { ContactList, ContactListMobile } from "./ContactList";
import { ContactCreateSheet } from "./ContactCreateSheet";
export const ContactCreate = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => {
  const goBack = useReturnToPrevious("/contacts");
  const mobile = useIsMobile();
  const location = useLocation();
  return (
    <>
      {mobile ? <ContactListMobile /> : <ContactList />}
      <ContactCreateSheet
        open
        mutationMode={mutationMode}
        defaultValues={location.state?.record}
        onOpenChange={(open) => {
          if (!open) goBack();
        }}
      />
    </>
  );
};
